// GET_SLIDER
export const GET_SLIDER = "GET_SLIDER";

// CREATE_SLIDER
export const CREATE_SLIDER = "CREATE_SLIDER";

// UPDATE_SLIDER
export const UPDATE_SLIDER = "UPDATE_SLIDER";

// DELETE_SLIDER
export const DELETE_SLIDER = "DELETE_SLIDER";
